import React from "react";
import ProductPreview from "./ProductPreview/ProductPreview";
import "./AuthCard.css";

/**
 * AuthCard — Centered card wrapper used on Login & Signup pages.
 */
export default function AuthCard({ heading, subtitle, children, footer }) {
  return (
    <div className="auth-page">
      <div className="auth-shell">
        <div className="auth-intro">
          <a className="auth-brand" href="/">
            MaiColleges
          </a>
          <h1>
            Start your summer college search <span>with one organized dashboard.</span>
          </h1>
          <p>Built for juniors beginning research before senior year. Compare schools, save notes, and turn a messy list into a dashboard you can actually use.</p>
          <div className="auth-trust-list" aria-label="Why students can trust MaiColleges">
            <span>College facts use U.S. Department of Education College Scorecard data.</span>
            <span>Built for students managing real applications, essays, deadlines, and tasks.</span>
          </div>
          <div className="auth-chips" aria-hidden="true">
            <span>Dashboards</span>
            <span>Progress</span>
            <span>Calendar</span>
            <span>Reminders</span>
          </div>
          <ProductPreview compact />
        </div>

        <div className="auth-panel">
          <div className="auth-card">
            <h2>{heading}</h2>
            <p>{subtitle}</p>
            {children}
          </div>

          {footer && <div className="auth-switch">{footer}</div>}
        </div>
      </div>

      <footer className="site-footer auth-footer">
        <span>© 2026 MaiColleges</span>
        <div>
          <a href="/about">About Us</a>
          <a href="/support">Support</a>
          <a href="/contact">Contact Us</a>
          <a href="https://docs.google.com/forms/d/e/1FAIpQLSeeM81wlBlaGlwaO5zZCo-3X0wP0wKe5kMuGodEffWcIXSx1w/viewform?usp=publish-editor" target="_blank" rel="noreferrer">Bug &amp; Feature Form</a>
          <a href="/privacy">Privacy</a>
          <a href="/terms">Terms</a>
        </div>
      </footer>
    </div>
  );
}
